//@ts-nocheck
import { Canvas } from "@react-three/fiber";
import { forwardRef } from "react";

import { View } from "../../utils/CustomView";

export const SharedCanvas = forwardRef((props, ref: any) => (
  <Canvas
    style={{
      position: "fixed",
      width: "100vw",
      height: "100vh",
      top: 0,
      zIndex: 20,
      pointerEvents: "none",
    }}
    gl={{
      stencil: false,
      autoClear: true,
      alpha: true,
      antialias: true,
      powerPreference: "high-performance",
    }}
    eventSource={props.eventSource}
    frameloop={"always"}
    ref={ref}
  >
    <View.Port></View.Port>
  </Canvas>
));
SharedCanvas.displayName = "SharedCanvas";
